(function(){
  var fine = window.matchMedia('(pointer:fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width:760px)').matches;

  /* ---------- page transition: reveal on enter ---------- */
  requestAnimationFrame(function(){ document.documentElement.classList.remove('ds-cover'); });

  /* ---------- smooth scroll ---------- */
  var lenis = null, scrollY = 0;
  if (!reduced && typeof Lenis !== 'undefined') {
    lenis = new Lenis({ duration: 1.5, easing: function(t){ return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    lenis.on('scroll', function(e){ scrollY = e.scroll; onScroll(); });
    window.__lenis = lenis;
    function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  } else {
    window.addEventListener('scroll', function(){ scrollY = window.scrollY; onScroll(); }, { passive: true });
  }

  /* anchor links through lenis */
  /* "Enter the library" (and FAQ) glide down. The time grows with the
     distance — 1.6s at least, 3s at most; ~1.85s for the 1400px trip to the
     catalogue on a phone — and the curve is ease-in-out sine: it starts and
     lands softly and its top speed is only ~1.6x the average, where the old
     0.9s cubic peaked near 3x and read as a jump. */
  function glideTo(el){
    if (lenis) {
      var dist = Math.abs(el.getBoundingClientRect().top - 70);
      lenis.scrollTo(el, {
        offset: -70,
        duration: Math.min(3, Math.max(1.6, 0.9 + dist / 1500)),
        easing: function(x){ return -(Math.cos(Math.PI * x) - 1) / 2; }
      });
    } else {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(ev){
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      ev.preventDefault();
      /* From the burger: close it first. That also restarts Lenis, which is
         stopped while the panel is open and would ignore the scroll. */
      if (a.closest('#dsMenu') && window.__dsCloseMenu) window.__dsCloseMenu();
      glideTo(el);
    });
  });

  /* ---------- header / top fade / back-to-top ---------- */
  var header = document.getElementById('header');
  var topFade = document.getElementById('topFade');
  var toTop = document.getElementById('toTop');
  function onScroll(){
    var y = lenis ? scrollY : window.scrollY;
    header.classList.toggle('is-scrolled', y > 40);
    topFade.classList.toggle('is-on', y > 40);
    toTop.classList.toggle('show', y > window.innerHeight * 0.9);
  }
  /* Lost once already: this listener used to sit between two blocks that were
     later deleted, and went with them. Keep it attached to its own element. */
  toTop.addEventListener('click', function(){
    if (lenis) lenis.scrollTo(0, { duration: 1.6 });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- burger menu ----------
     The homepage layout carries none of Dawn's JS, so the drawer is driven
     here. [hidden] is removed first so the panel can transition in, and put
     back after the circle has closed — otherwise it stays in the tab order.
     The circle is centred on the burger, measured on every open because the
     header shrinks once the page has scrolled. */
  var burger = document.getElementById('dsBurger');
  var menu = document.getElementById('dsMenu');
  if (burger && menu) {
    var menuOpen = false, hideTimer;
    function setMenu(open){
      menuOpen = open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      clearTimeout(hideTimer);
      if (open) {
        var b = burger.getBoundingClientRect();
        menu.style.setProperty('--ds-cx', (b.left + b.width / 2) + 'px');
        menu.style.setProperty('--ds-cy', (b.top + b.height / 2) + 'px');
        menu.hidden = false;
        void menu.offsetWidth;           // commit the closed circle before growing it
        menu.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        if (lenis) lenis.stop();
      } else {
        menu.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        if (lenis) lenis.start();
        hideTimer = setTimeout(function(){ menu.hidden = true; }, 620);
      }
    }
    window.__dsCloseMenu = function(){ if (menuOpen) setMenu(false); };
    burger.addEventListener('click', function(){ setMenu(!menuOpen); });
    menu.addEventListener('click', function(e){ if (e.target.tagName === 'A') setMenu(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && menuOpen) setMenu(false); });
  }

  /* ---------- arriving from "FAQ" on another page ----------
     ds-home.liquid has already taken #faq off the URL. Wait for the
     first-visit preloader (if it is showing) and the 620ms page reveal,
     then glide down from the top. */
  if (window.__dsGoFaq) {
    var faqBlock = document.getElementById('faq');
    if (faqBlock) (function wait(n){
      var pl = document.getElementById('ds-preloader');
      if (pl && pl.style.display !== 'none' && n < 60) { setTimeout(function(){ wait(n + 1); }, 100); return; }
      setTimeout(function(){ glideTo(faqBlock); }, 700);
    })(0);
  }

  /* ---------- advantages: one point in focus, like a roulette ----------
     While the list is on screen, the point whose middle is nearest the
     middle of the screen has .is-focus (bigger, coloured — see ds-home.css);
     all the others lose it. Each time a point takes focus a light runs
     across its title: .adv-glint for as long as it takes to cross, with --gi
     numbering the letters so they flash one after another. Measured in one
     rAF per scroll frame, and only near the block. */
  var advWrap = document.querySelector('.adv-list-wrap');
  if (advWrap) {
    var advItems = [].slice.call(advWrap.querySelectorAll('.adv-item'));
    var advQueued = false;
    function advGlint(it){
      if (reduced) return;
      var chars = it.querySelectorAll('.adv-item-title .ds-char');
      if (!chars.length) return;
      [].forEach.call(chars, function(c, i){ c.style.setProperty('--gi', i); });
      clearTimeout(it._glintTimer);
      it.classList.remove('adv-glint');
      void it.offsetWidth;                     // restart the light if it was still running
      it.classList.add('adv-glint');
      it._glintTimer = setTimeout(function(){ it.classList.remove('adv-glint'); }, chars.length * 22 + 1200);
    }
    function advUpdate(){
      advQueued = false;
      var r = advWrap.getBoundingClientRect(), vh = window.innerHeight, mid = vh * 0.5;
      if (r.bottom < -vh || r.top > vh * 2) return;
      var best = -1, bestD = Infinity;
      if (r.top < vh * 0.85 && r.bottom > vh * 0.15) {
        advItems.forEach(function(it, i){
          var b = it.getBoundingClientRect(), d = Math.abs(b.top + b.height / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
      }
      advItems.forEach(function(it, i){
        var focus = i === best;
        if (focus && !it.classList.contains('is-focus')) advGlint(it);
        if (!focus && it.classList.contains('adv-glint')) {   // left focus mid-light: let it go grey now
          clearTimeout(it._glintTimer);
          it.classList.remove('adv-glint');
        }
        it.classList.toggle('is-focus', focus);
      });
    }
    function advQueue(){ if (!advQueued) { advQueued = true; requestAnimationFrame(advUpdate); } }
    if (lenis) lenis.on('scroll', advQueue); else window.addEventListener('scroll', advQueue, { passive: true });
    window.addEventListener('resize', advQueue);
    advUpdate();
  }

  /* ---------- scroll reveals (blocks) ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  /* Tells the layout's load watchdog that reveals are wired; if this line is
     never reached the watchdog un-hides everything instead. */
  document.documentElement.classList.add('ds-rv-ready');

  /* ---------- letter-assemble headings ---------- */
  function letterize(node){
    var chars = [];
    [].slice.call(node.childNodes).forEach(function(n){
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function(part){
          if (part === '') return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var word = document.createElement('span'); word.className = 'ds-word';
          [].forEach.call(part, function(ch){
            var s = document.createElement('span'); s.className = 'ds-char'; s.textContent = ch;
            word.appendChild(s); chars.push(s);
          });
          frag.appendChild(word);
        });
        node.replaceChild(frag, n);
      } else if (n.nodeType === 1) {
        if (n.tagName === 'BR') return;
        chars = chars.concat(letterize(n));
      }
    });
    return chars;
  }
  var splits = [].slice.call(document.querySelectorAll('.ds-split'));
  if (reduced) {
    splits.forEach(function(el){ el.style.visibility = 'visible'; });
  } else {
    var splitIO = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { en.target.classList.add('in'); splitIO.unobserve(en.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    splits.forEach(function(el){
      var chars = letterize(el);
      chars.forEach(function(c, i){ c.style.animationDelay = (i * 0.022).toFixed(3) + 's'; });
      el.style.visibility = 'visible';
      splitIO.observe(el);
    });
  }

  /* ---------- magnetic buttons (proximity — pulls before hover) ---------- */
  if (fine && !reduced) {
    var magnets = [].slice.call(document.querySelectorAll('.btn'));
    var PAD = 45, mmx = -1, mmy = -1, mmActive = false;
    window.addEventListener('mousemove', function(e){ mmx = e.clientX; mmy = e.clientY; mmActive = true; }, { passive: true });
    (function magnetLoop(){
      if (mmActive) {
        var vh = window.innerHeight;
        for (var i = 0; i < magnets.length; i++) {
          var b = magnets[i], r = b.getBoundingClientRect();
          if (r.bottom < -60 || r.top > vh + 60) { if (b.style.transform) b.style.transform = ''; continue; }
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          var dx = mmx - cx, dy = mmy - cy;
          var range = Math.max(r.width, r.height) / 2 + PAD;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < range) {
            var pull = 0.18 * (1 - dist / range);
            b.style.transform = 'translate(' + (dx * pull).toFixed(1) + 'px,' + (dy * pull).toFixed(1) + 'px)';
          } else if (b.style.transform) {
            b.style.transform = '';
          }
        }
      }
      requestAnimationFrame(magnetLoop);
    })();
  }

  /* ---------- tilt cards (3D toward cursor) ---------- */
  if (fine && !reduced) {
    document.querySelectorAll('.asset-cover').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateX(' + (-py * 5).toFixed(2) + 'deg) rotateY(' + (px * 5).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = ''; });
    });
  }

  /* ---------- blur-up image load ---------- */
  document.querySelectorAll('.asset-img-1').forEach(function(img){
    if (reduced) return;
    img.classList.add('ds-blurup');
    if (img.complete && img.naturalWidth) img.classList.add('ds-loaded');
    else img.addEventListener('load', function(){ img.classList.add('ds-loaded'); }, { once: true });
  });



  onScroll();
})();

/* ---------- prefetch internal pages on hover (instant navigation) ---------- */
(function(){
  var seen={}, n=0;
  function prefetch(url){
    if(seen[url]||n>12)return; seen[url]=1; n++;
    var l=document.createElement('link'); l.rel='prefetch'; l.href=url;
    document.head.appendChild(l);
  }
  function onHint(e){
    var a=e.target&&e.target.closest&&e.target.closest('a'); if(!a)return;
    var h=a.getAttribute('href');
    if(!h||h.charAt(0)==='#'||h.indexOf('mailto:')===0||h.indexOf('tel:')===0)return;
    if(a.target==='_blank'||a.hasAttribute('download'))return;
    if(a.hostname&&a.hostname!==location.hostname)return;
    if(a.href===location.href)return;
    prefetch(a.href);
  }
  document.addEventListener('mouseover',onHint,{passive:true});
  document.addEventListener('touchstart',onHint,{passive:true});
})();


/* ---------- letter-assemble text auto (site-wide, extends .ds-split) ---------- */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = 'h1, h2, h3, h4';
  var SKIP = '.brand, .nav-link, .btn, .button, .price, [data-nosplit]';
  function letterize(node){
    var chars=[];
    [].slice.call(node.childNodes).forEach(function(n){
      if(n.nodeType===3){
        var frag=document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function(part){
          if(part==='')return;
          if(/^\s+$/.test(part)){frag.appendChild(document.createTextNode(part));return;}
          var word=document.createElement('span');word.className='ds-word';
          [].forEach.call(part,function(ch){var s=document.createElement('span');s.className='ds-char';s.textContent=ch;word.appendChild(s);chars.push(s);});
          frag.appendChild(word);
        });
        node.replaceChild(frag,n);
      } else if(n.nodeType===1){
        if(n.tagName==='BR')return;
        if(n.classList&&n.classList.contains('ds-char'))return;
        chars=chars.concat(letterize(n));
      }
    });
    return chars;
  }
  var targets=[].slice.call(document.querySelectorAll(SEL)).filter(function(el){
    if(el.classList.contains('ds-split'))return false;
    if(SKIP&&el.closest(SKIP))return false;
    if(el.querySelector('img,svg,input,select,textarea,button,iframe,video'))return false;
    var t=(el.textContent||'').replace(/\s+/g,' ').trim();
    if(!t||t.length>160)return false;
    return true;
  });
  if(!targets.length)return;
  if(reduced){ targets.forEach(function(el){el.classList.add('ds-split','in');}); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);} });
  },{threshold:0.12, rootMargin:'0px 0px -6% 0px'});
  targets.forEach(function(el){
    var chars=letterize(el);
    chars.forEach(function(c,i){ c.style.animationDelay=Math.min(i*0.02,0.5).toFixed(3)+'s'; });
    el.classList.add('ds-split');
    el.style.visibility='visible';
    io.observe(el);
  });
})();

/* ---------- smooth block fade for paragraphs (light blur) ---------- */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = 'p';
  var SKIP = '.brand, .nav-link, .btn, .button, .price, .caption, .rv, [data-nosplit]';
  var targets=[].slice.call(document.querySelectorAll(SEL)).filter(function(el){
    if(el.classList.contains('ds-split')||el.classList.contains('ds-fade'))return false;
    if(SKIP&&el.closest(SKIP))return false;
    var t=(el.textContent||'').replace(/\s+/g,' ').trim();
    if(t.length<20)return false;
    return true;
  });
  if(!targets.length)return;
  if(reduced){ targets.forEach(function(el){el.classList.add('ds-fade','in');}); return; }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);} });
  },{threshold:0.06, rootMargin:'0px 0px -4% 0px'});
  targets.forEach(function(el){ el.classList.add('ds-fade'); io.observe(el); });
})();


/* ===== cursor ring (rogi-style) ===== */
(function(){
  if(!window.matchMedia||!window.matchMedia('(pointer:fine)').matches)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var dot=document.createElement('div');dot.className='ds-cursor';dot.appendChild(document.createElement('i'));
  (document.body||document.documentElement).appendChild(dot);
  document.documentElement.classList.add('ds-cursor-on');
  var x=window.innerWidth/2,y=window.innerHeight/2,tx=x,ty=y,shown=false;
  window.addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;
    if(!shown){shown=true;dot.style.opacity='1';}
    var t=e.target;
    dot.classList.toggle('is-hover',!!(t&&t.closest&&t.closest('a,button,.btn,summary,[role=button]')));
  },{passive:true});
  document.addEventListener('mouseleave',function(){dot.style.opacity='0';shown=false;});
  (function loop(){x+=(tx-x)*0.2;y+=(ty-y)*0.2;
    dot.style.transform='translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,0) translate(-50%,-50%)';
    requestAnimationFrame(loop);})();
})();

/* ===== header word-roll on hover ===== */
(function(){
  var els=document.querySelectorAll('.nav-link, .brand-word');
  [].forEach.call(els,function(el){
    var host=el;
    if(el.children.length===1&&el.firstElementChild.tagName==='SPAN'&&!el.firstElementChild.children.length){host=el.firstElementChild;}
    if(host.children.length)return;
    var txt=(host.textContent||'').trim(); if(!txt)return;
    host.textContent='';
    var roll=document.createElement('span');roll.className='ds-roll';
    var col=document.createElement('span');col.className='ds-roll-col';
    var a=document.createElement('span');a.textContent=txt;
    var b=document.createElement('span');b.setAttribute('aria-hidden','true');b.setAttribute('data-t',txt);
    col.appendChild(a);col.appendChild(b);roll.appendChild(col);host.appendChild(roll);
  });
})();
